module.exports = __webpack_public_path__ + "static/media/7.3e8c2c12.PNG";